import {
    Box,
    Button, ListItemSecondaryAction,
    Paper,
    Tab,
    Tabs,
    TextField
} from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import React, { useState } from "react";
import toastr from "toastr";
import SharePop from "../../components/common/shareLivestream";
import {
    copyToClipboard, validEmail
} from "../../helpers/utility";
import SocialAPI from "../../store/social/social.api";
import { getImage } from "../../store/user/user.selector";

export default function SharingUploadVideo(props) {
    const { shareUrl, userProfile, onClose } = props;
    const [mode, setMode] = useState("Share");
    const [title, setTitle] = useState("");
    const [emails, setEmails] = useState([]);
    const [email, setEmail] = useState("");

    return (
        <>
            <Paper square>
                <Tabs
                    variant="fullWidth"
                    value={mode}
                    maxWidth={false}
                    indicatorColor="secondary"
                    textColor="secondary"
                    onChange={(e, val) => {
                        setMode(val);
                    }}
                >
                    <Tab
                        value="Share"
                        fullWidth
                        label={"Share"}
                    />
                    <Tab
                        value="Social"
                        fullWidth
                        label={"Social"}
                    />
                    <Tab
                        value="Embed"
                        fullWidth
                        label={"Embed"}
                    />
                </Tabs>
            </Paper>
            {mode === "Social" ? (
                <Box className="p-3">
                    <SharePop
                        onClose={() => setMode("Share")}
                        shareUrl={shareUrl}
                        title={userProfile.fullName}
                        subTitle={"@" + userProfile.userName}
                        image={getImage(userProfile.attachments)}
                        heading=""
                    />
                </Box>
            ) : mode === "Share" ? (
                <Box>
                    <label className="text-bold mt-2">
                        <br />
                        Share to people
                    </label>
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        value={email}
                        onChange={(e) =>
                            setEmail(e.target.value)
                        }
                        onKeyPress={(e) => {
                            if (
                                e.key.toLowerCase() ===
                                "enter"
                            ) {
                                if (validEmail(email)) {
                                    setEmails([
                                        ...emails,
                                        email,
                                    ]);
                                    setEmail("");
                                }
                            }
                        }}
                        placeholder="Type email and press enter"
                    />
                    <ul className="my-2">
                        {emails.length > 0 ? (
                            emails.map((x, index) => {
                                return (
                                    <li>
                                        {index +
                                            1 +
                                            ". " +
                                            x}
                                    </li>
                                );
                            })
                        ) : (
                            <span />
                        )}
                    </ul>
                    <div className="float-right my-2">
                        <Button
                            onClick={() => {
                                setTitle("");
                                setEmails([]);
                                onClose();
                            }}
                            disableElevation
                            color="default"
                            className="bgWhite"
                            size="small"
                            variant="contained"
                        >
                            Retake
                        </Button>
                        &nbsp;&nbsp;
                        <Button
                            onClick={() => {
                                let mail = `<p style="text-align: center; color:#000; font-size: 22px; font-weight: 600;">
                  My new recording is uploaded
                  </p>
                  <p style="line-height: 30px; text-align:center">
                      Hello,<br />
                      <span style="color:#8B22F9">${userProfile.fullName}</span> has uploaded a recording.<br/>
                      Here are the recording details
                  </p>
                  <p style="text-align:center;background:#F1F1F1;">
                      <br />
                      <span style="color:#8B22F9">Title</span>: ${title}<br />
                              <span style="color:#8B22F9">Description</span>: ${title}<br />
                      <br />
                  </p>`;

                                emails.forEach((xs) => {
                                    SocialAPI.sendEmailNotification(
                                        {
                                            message:
                                                mail,
                                            subject:
                                                "New Recording From Ulalive",
                                            to: xs,
                                        }
                                    );
                                });

                                if (emails.length > 0) {
                                    toastr.success(
                                        "Email sent successfully",
                                        "Instant Video"
                                    );
                                }
                            }}
                            disableElevation
                            color="default"
                            size="small"
                            variant="contained"
                        >
                            Share
                        </Button>
                    </div>
                    <br clear="all" />
                    <List disablePadding>
                        <ListItem disableGutters>
                            <ListItemText
                                primary="Privacy settings"
                                secondary="Anyone with the link can view"
                            />
                            <ListItemSecondaryAction className="mt-2">
                                <input
                                    type="text"
                                    style={{
                                        visibility:
                                            "hidden",
                                    }}
                                    value={shareUrl}
                                    id="myInput2"
                                />
                                <Button
                                    onClick={() =>
                                        copyToClipboard(
                                            "myInput2"
                                        )
                                    }
                                    size="small"
                                    disableElevation
                                    color="primary"
                                    variant="contained"
                                >
                                    Copy link
                                </Button>
                            </ListItemSecondaryAction>
                        </ListItem>
                    </List>
                </Box>
            ) : (
                <Box>
                    <TextField
                        id="myInput"
                        fullWidth
                        variant="outlined"
                        minRows={4}
                        multiline
                        inputProps={{
                            maxLength: 80,
                        }}
                        value={`<iframe src="${shareUrl + "#embed"
                            }" width="640" height="480" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`}
                        className="my-2"
                    />
                    <Button
                        className="my-2 float-right"
                        onClick={() =>
                            copyToClipboard("myInput")
                        }
                        color="primary"
                        variant="contained"
                    >
                        Copy to clipboard
                    </Button>
                    <br clear="all" />
                </Box>
            )}
        </>
    );
}
